import { BlockTypes, richTextResolver } from "@storyblok/richtext";

const resolver = richTextResolver({
  resolvers: {
    [BlockTypes.COMPONENT]: (node: any) => {
      const blok = node?.attrs?.body?.[0];
      if (blok?.component === "underOverlineText") {
        return `<h3 class="under-overline-text">${blok.text || ""}</h3>`;
      }
      return "";
    },
  },
});

export const renderRichText = (doc: any): string => {
  if (!doc) {
    return "";
  }
  return resolver.render(doc) as string;
};
